<glxy-form-field>
  <glxy-label>
    {{ label | translate }}
  </glxy-label>
  <mat-select [formControl]="boolInputControl">
    <ng-container *ngFor="let option of boolOptions">
      <mat-option [value]="option.value">
        {{ option.label | translate }}
      </mat-option>
    </ng-container>
  </mat-select>
</glxy-form-field>
